var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInvalid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73302 4.00006L7.84812 0.884861C8.05085 0.68223 8.05085 0.354604 7.84812 0.151973C7.64549 -0.0506577 7.31786 -0.0506577 7.11523 0.151973L4.00004 3.26717L0.884932 0.151973C0.682206 -0.0506577 0.354675 -0.0506577 0.152044 0.151973C-0.0506814 0.354604 -0.0506814 0.68223 0.152044 0.884861L3.26715 4.00006L0.152044 7.11526C-0.0506814 7.31789 -0.0506814 7.64551 0.152044 7.84815C0.253027 7.94922 0.385805 8 0.518488 8C0.651171 8 0.783854 7.94922 0.884932 7.84815L4.00004 4.73295L7.11523 7.84815C7.21631 7.94922 7.34899 8 7.48168 8C7.61436 8 7.74704 7.94922 7.84812 7.84815C8.05085 7.64551 8.05085 7.31789 7.84812 7.11526L4.73302 4.00006Z",
    fill: "#DA293E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvalid);
export default __webpack_public_path__ + "static/media/IconInvalid.b06ff3428beb40c753a9a4282e4969e9.svg";
export { ForwardRef as ReactComponent };